/* eslint-disable */

import React, {FC, useEffect, useState} from "react";
import {ChartLineBars} from "../index";
import {useStyles} from "../../style";
import {
    Box,
    Card, CardContent,
    Checkbox, Divider,
    FormControlLabel,
    FormGroup,
    Grid, IconButton,
    Tooltip,
    Typography,
    withStyles
} from "@material-ui/core";
import Chart from "react-apexcharts";
import Scrollbar from "../../../../Scrollbar";
import es from "../../../../../assets/languagePackages/es.json";
import estadoFlujoIcon from "../../../../../assets/icons/estadoFlujoIcon.svg";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const months = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
];

const ChartLineBar: FC<any> = (props) => {
    const { flujoEfectivo, ...other } = props;
    const timeCurrent = Date.now();
    const date = new Date(timeCurrent);
    const classes = useStyles();
    const [dataFEFin, setDataFEFin] = useState([]);
    const [dataFEOpe, setDataFEOpe] = useState([]);
    const [dataFEInv, setDataEFInv] = useState([]);
    const [dataCambioNeto, setDataCambioNeto] = useState([]);
    const [seriesArray, setSeriesArray] = useState([]);


    const state = {
        series: seriesArray,
        options: {
            chart: {
                locales: [es],
                fontFamily: 'Roboto, sans-serif',
                defaultLocale: 'es',
                height: 400,
                toolbar: {
                    show: true,
                },
            },
            stroke: {
                width: [2, 2, 2, 2],
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                },
            },
            xaxis: {
                type: 'datetime',
            },
            yaxis: {
                labels: {
                    formatter: function (y) {
                        const formattedValue = y.toLocaleString(undefined, {
                            style: 'currency',
                            currency: 'USD',
                        });
                        return formattedValue;
                    }
                }
            },
            legend: {
                height: '25px',
                offsetY: 8,
                itemMargin: {
                    horizontal: 4,
                    vertical: 20,
                },
            },
        //     tooltip: {
        //         enabled: true,
        //         intersect: false,
        //         custom: function({series, seriesIndex, dataPointIndex, w}) {
        //             const data = w.config.series;
        //             console.log(data);
        //             const nameNeta = w.config.series[0].name;
        //             const nameRetenida = w.config.series[1].name;
        //             const netaValue = w.config.series[seriesIndex].data[dataPointIndex] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex] : [null,0];
        //             const date = new Date(netaValue[0]);
        //             const day = String(date.getUTCDate()).padStart(2, '0');
        //             const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        //             const year = String(date.getUTCFullYear()).slice(-2);
        //             const formattedNetaValue = series[seriesIndex][dataPointIndex].toLocaleString(undefined, {
        //                 style: 'currency',
        //                 currency: 'USD',
        //             });
        //             const formattedRetenidaValue = series[1][dataPointIndex].toLocaleString(undefined, {
        //                 style: 'currency',
        //                 currency: 'USD',
        //             });
        //             const bgColor = netaValue[1] < 0 ? '#fac004' : '#024788';
        //             const formattedDate = `${day}/${month}/${year}`;
        //             return `
        //     <div style="border-radius:5px">
        //         <div style="display:flex;background:#ECEFF1;border-bottom:thin solid #ddd;padding-top:10px;padding-left:10px;padding-right:10px;padding-bottom:5px">
        //             <p style="margin-left:5px">Fecha: <span style="font-weight:bold">${formattedDate}</span></p>
        //         </div>
        //         <div style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:5px">
        //             <div style="display:flex;align-items:center">
        //                 <span style="background-color:${bgColor};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
        //                 <p>${nameNeta}: <span style="font-weight:bold">${formattedNetaValue}</span></p>
        //             </div>
        //             <div style="display:flex;align-items:center">
        //                 <span style="background-color:#6AA8C7;width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
        //                 <p>${nameRetenida}: <span style="font-weight:bold">${formattedRetenidaValue}</span></p>
        //             </div>
        //         </div>
        //     </div>
        // `
        //         }
        //     },
            toolbar: {
                show: false,
            },
        },
    };

    const [chartView, setChartView] = useState({
        checkedA: true,
        checkedB: true,
        checkedC: true,
        checkedD: true,
    });

    const handleChange = (event) => {
        setChartView({ ...chartView, [event.target.name]: event.target.checked });
    };

    useEffect(() => {
        setDataCapitalTrabajo();
    }, [chartView, flujoEfectivo]);

    const setDataCapitalTrabajo = () => {
        let tempDataFEOpe = [];
        let tempDataFEFin = [];
        let tempDataFEInv = [];
        let tempDataCambioNeto = [];
        let tempFinalArray = [];
        if (
            flujoEfectivo['Flujo de Efectivo de las Operaciones'] !== undefined &&
            flujoEfectivo['Flujo de Efectivo de las Inversiones'] !== undefined &&
            flujoEfectivo['Flujo de Efectivo de Financiamiento'] !== undefined &&
            flujoEfectivo['Cambio Neto de Efectivo'] !== undefined &&
            flujoEfectivo['Flujo de Efectivo de las Operaciones'] !== null &&
            flujoEfectivo['Flujo de Efectivo de las Inversiones'] !== null &&
            flujoEfectivo['Flujo de Efectivo de Financiamiento'] !== null &&
            flujoEfectivo['Cambio Neto de Efectivo'] !== null
        ) {
            if (chartView.checkedA === true) {
                tempDataFEOpe = flujoEfectivo['Flujo de Efectivo de las Operaciones'];
                setDataFEOpe(tempDataFEOpe);
                const tmpDataFEO = {
                    name: 'Flujo de Efectivo de las Operaciones',
                    type: 'line',
                    data: tempDataFEOpe,
                    color: '#024787',
                };
                tempFinalArray.push(tmpDataFEO);
            } else {
                setDataFEOpe([]);
            }
            if (chartView.checkedB === true) {
                tempDataFEInv = flujoEfectivo['Flujo de Efectivo de las Inversiones'];
                setDataEFInv(tempDataFEInv);
                const tmpDataFEI = {
                    name: 'Flujo de Efectivo de las Inversiones',
                    type: 'line',
                    data: tempDataFEInv,
                    color: '#1375cf',
                };
                tempFinalArray.push(tmpDataFEI);
            } else {
                setDataEFInv([]);
            }
            if (chartView.checkedC === true) {
                tempDataFEFin = flujoEfectivo['Flujo de Efectivo de Financiamiento'];
                setDataFEFin(tempDataFEFin);
                const tmpDataFEF = {
                    name: 'Flujo de Efectivo de Financiamiento',
                    type: 'line',
                    data: tempDataFEFin,
                    color: '#a1a1a1',
                };
                tempFinalArray.push(tmpDataFEF);
            } else {
                setDataFEFin([]);
            }
            if (chartView.checkedD === true) {
                tempDataCambioNeto = flujoEfectivo['Cambio Neto de Efectivo'];
                setDataCambioNeto(tempDataCambioNeto);
                const tmpDataCNE = {
                    type: 'line',
                    data: tempDataCambioNeto,
                    color: '#5d6a83',
                    name: 'Cambio Neto de Efectivo',
                };
                tempFinalArray.push(tmpDataCNE);
            } else {
                setDataCambioNeto([]);
            }
        }
        setSeriesArray(tempFinalArray);
    };

    return (
        <Box
            sx={{
                backgroundColor: 'background.default',
                p: 1,
            }}
        >
            <Card sx={{ p: 2 }}>
                <Grid sx={{ paddingTop: '10px' }} container spacing={0}>
                    <Grid className={classes.chartLineBarsBox} item xs={12} md={4}>
                        <Box mr={1}>
                            <img src={estadoFlujoIcon} alt="roundWorkHistory" width="35px" height="35px"/>
                        </Box>
                        <Typography className={classes.chartBarDonutTitle}>
                            Estado de Flujo de Efectivo
                        </Typography>
                    </Grid>
                    <Grid className={classes.chartLineBarsBox} item xs={10} md={7}>
                        <FormGroup row>
                            <FormControlLabel
                                className={classes.checkBoxChartLine}
                                control={
                                    <Checkbox
                                        checked={chartView.checkedA}
                                        onChange={handleChange}
                                        name="checkedA"
                                        color="primary"
                                    />
                                }
                                label={
                                    <Typography className={classes.chartBarLineText}>
                                        Flujo de Efectivo de las Operaciones
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                className={classes.checkBoxChartLine}
                                control={
                                    <Checkbox
                                        checked={chartView.checkedB}
                                        onChange={handleChange}
                                        name="checkedB"
                                        color="primary"
                                    />
                                }
                                label={
                                    <Typography className={classes.chartBarLineText}>
                                        Flujo de Efectivo de las Inversiones
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                className={classes.checkBoxChartLine}
                                control={
                                    <Checkbox
                                        checked={chartView.checkedC}
                                        onChange={handleChange}
                                        name="checkedC"
                                        color="primary"
                                    />
                                }
                                label={
                                    <Typography className={classes.chartBarLineText}>
                                        Flujo de Efectivo de Financiamiento
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                className={classes.checkBoxChartLine}
                                control={
                                    <Checkbox
                                        checked={chartView.checkedD}
                                        onChange={handleChange}
                                        name="checkedD"
                                        color="primary"
                                    />
                                }
                                label={
                                    <Typography className={classes.chartBarLineText}>
                                        Cambio Neto de Efectivo
                                    </Typography>
                                }
                            />
                        </FormGroup>
                    </Grid>
                    {/*<Grid className={classes.chartLineBarsBox} item xs={2} md={1}>*/}
                    {/*    <IconButton>*/}
                    {/*        <LightTooltip title="Comparación histórica entre el CCE y el CT con el fin de mostrar el valor monetario que necesita la compañía para financiar sus operaciones en relación con los días que toma convertir en efectivo las obligaciones financieras para contrarrestar dicho financiamiento.">*/}
                    {/*            <span>i</span>*/}
                    {/*        </LightTooltip>*/}
                    {/*    </IconButton>*/}
                    {/*</Grid>*/}
                </Grid>
                <Divider />
                <CardContent>
                    <Scrollbar>
                        <Box
                            sx={{
                                minWidth: 500,
                                position: 'relative',
                            }}
                        >
                            <div className={classes.chartLine}>
                                <Chart
                                    height="400"
                                    options={state.options}
                                    series={state.series}
                                />
                            </div>
                        </Box>
                    </Scrollbar>
                </CardContent>
            </Card>
        </Box>
    );


}

export default ChartLineBar;
